@if (config(); as alertConfig) {
  <div
    class="v-one-alert"
    tabindex="-1"
    (keydown)="onKeydown($event)"
    aria-modal="true"
    role="alertdialog"
    [attr.aria-labelledby]="'alert-title'"
    [attr.aria-describedby]="'alert-message'"
    aria-live="assertive"
    [attr.aria-label]="alertConfig.title + '. ' + alertConfig.message"
  >
    <div
      class="v-one-alert__backdrop"
      (click)="onClose()"
      (keydown)="onKeydown($event)"
      tabindex="0"
      role="button"
      aria-label="Cerrar alerta"
    ></div>

    <div
      [class]="getAlertClasses()"
      tabindex="0"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()"
    >
      <!-- Alert Header -->
      <div class="v-one-alert__header">
        @if (alertConfig.showIcon !== false && safeIconSvg(); as iconSvg) {
          <div class="v-one-alert__icon" [innerHTML]="iconSvg"></div>
        }

        <h2 id="alert-title" class="v-one-alert__title">
          {{ alertConfig.title }}
        </h2>

        @if (alertConfig.showClose) {
          <button
            class="v-one-alert__close-button"
            (click)="onClose()"
            aria-label="Cerrar alerta"
            type="button"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        }
      </div>

      <!-- Alert Content -->
      <div class="v-one-alert__content">
        <p id="alert-message" class="v-one-alert__message">
          {{ alertConfig.message }}
        </p>
      </div>

      <!-- Alert Actions -->
      <div class="v-one-alert__actions">
        @if (alertConfig.rejectText) {
          <button
            [class]="getButtonClasses('reject')"
            (click)="onReject()"
            type="button"
          >
            {{ alertConfig.rejectText }}
          </button>
        }

        @if (alertConfig.acceptText) {
          <button
            [class]="getButtonClasses('accept')"
            (click)="onAccept()"
            type="button"
          >
            {{ alertConfig.acceptText }}
          </button>
        }
      </div>
    </div>
  </div>
}
